let locks = 0;
let restore;

/** Shared by modal surfaces; nested locks restore the page only after the last release. */
export const lockPageScroll = () => {
    if (locks === 0) {
        const root = document.documentElement;
        const body = document.body;
        const position = { left: window.scrollX, top: window.scrollY };
        const previous = ['position', 'top', 'width', 'overflow'].map((key) => [key, body.style[key]]);
        const rootOverflow = root.style.overflow;
        const width = body.getBoundingClientRect().width;
        root.style.overflow = 'hidden';
        Object.assign(body.style, { position: 'fixed', top: `${-position.top}px`, width: `${width}px`, overflow: 'hidden' });
        restore = () => {
            previous.forEach(([key, value]) => { body.style[key] = value; });
            root.style.overflow = rootOverflow;
            window.scrollTo({ ...position, behavior: 'instant' });
        };
    }
    locks += 1;
    let released = false;
    return () => {
        if (released) return;
        released = true;
        locks -= 1;
        if (locks === 0) restore();
    };
};
